import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Row, Col, Table, Tabs, Tab,  } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import { Prev } from 'react-bootstrap/esm/PageItem';
import { Link } from 'react-router-dom';

import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDADDRESSSAVE, ULDSTATIONDETAILS, ULDADDRESSACTARC, ULDADDRESSRECMAIL, DELETERECEMAIL, STATIONLIST, SAVEHANDLER, STATIONHANDLER } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';

const RecoveryStationDetails = ({ rowData, stationID, reload }) => {

    console.log('999', rowData);
    const isMounted = useRef(false);
    const [show, setShow] = useState(false);
    const modalShow = () => {setShow(true); setEditMode('A')}
    const modalClose = () => setShow(false);
    const storedData = rowData.args.Address;

    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
    });
    const [address, setAddress] = useState(storedData);
    const [getDestination, setGetDestination] = useState([]);
    const [handlerList, setHandlerList] = useState([]);

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end
    // Validation 
    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_org_id) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        else {
            return isValid;
        }
    };


    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateFormData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            const stationid = rowData.station_id;
            const NewInputAddress = { ...inputAddress, station_id: stationid };

            const dataToSend = {
                station_id: stationid,
                company_name: inputAddress.company_name,
                agent_or_handler: inputAddress.agent_or_handler,
                address: inputAddress.address,
                email: inputAddress.email,
                phone_number: inputAddress.phone_number
            };
            // console.log("🚀 ~ addAddress ~ dataToSend:", dataToSend)

            if (inputAddress.agent_or_handler === 'A') {
                dataToSend.agent_type = inputAddress.agent_type;
            }

            // const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(SAVEHANDLER, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            // console.log("🚀 ~ .then ~ innerData:", innerData)
                            if (res.data.response_code == 200) {
                                fetchDataGrid();
                                // setAddress(res.data.response_data);
                                setInputAddress({
                                    handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                                });
                                modalClose();
                                reload()
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }

        }
    }
    // const handleChange = (e) => {
    //     setInputAddress({ ...inputAddress, [e.target.name]: e.target.value });
    // };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };

    useEffect(() => {
        // localStorage.setItem("StationAddress", JSON.stringify(address));
    }, [rowData]);

    const [selectedAddress, setSelectedAddress] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [editMode, setEditMode] = useState('');
    const modalEditShow = (data) => {
        setShowEdit(true);
        setShow(true);
        setEditMode('E')
        setInputAddress(data)
    }
    const modalEditClose = () => setShowEdit(false);

    const handleEditChange = (e) => {
        setSelectedAddress(Prev => ({ ...Prev, [e.target.name]: e.target.value }));
    };

    const editAddress = async () => {
        // const updatedAddress = { ...selectedAddress, address_id: selectedAddress.address_id };
        try {
            const res = await withRFSToken.post(ULDADDRESSSAVE, selectedAddress)
                .then(function (res) {
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        const innerData = res.data.response_data;
                        // fetchDataGrid();
                        // setAddress(res.data.response_data);
                        setSelectedRowData(innerData);
                        const transformedData = {
                            ...innerData,
                            // agent_type: innerData.regd,
                            email: innerData.contact_email
                        };
                        setSelectedAddress(transformedData);
                        fetchDataGrid();
                        // setSelectedAddress({
                        //     company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: '', phone_number: ''
                        // });
                        modalEditClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    // const [selectAddress, setSelectAddress] = useState(false);
    // const [selectedAddress, setSelectedAddress] = useState(null);

    // const addressDetails = (addressID) => {
    //     // Find the selected address by its addressID
    //     const updatedSelects = address.map(ads => ({ ...ads, selected: false }));
    //     const updatedSelect = updatedSelects.find(ads => ads.id === addressID);

    //     if (updatedSelect) {
    //         updatedSelect.selected = true;
    //     }
    //     setAddress(updatedSelects);
    //     // setSelectAddress(!selectAddress);
    //     const selected = address.find((addr) => addr.id === addressID);
    //     setSelectedAddress(selected);
    // };
    // Grid Start
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: []

    });
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    console.log("🚀 ~ innerData:", innerData)
                    const findData = innerData.find(id => id.station_id === rowData.station_id)
                    console.log("🚀 ~ findData:", findData)
                    setGridData({ Active: findData.address, Archived: '' });
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAddressData = async () => {
        try {

            const res = await withRFSToken.post(STATIONHANDLER, {stationId: rowData.station_id})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.handler_org_id,
                        label: item.org_name,
                        email: [item.handler_email_id] || []
                    })) : [];
                    setHandlerList(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchDataGrid();
        fetchAddressData();
        isMounted.current = true;
    }, []);
    const [activeTab, setActiveTab] = useState('Active');
    const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null)
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    const handleDetailsBackClick = (rowData) => {
        // setSelectedRowData(rowData);
        setShowDetails(false);
    };

    useEffect(() => {

        if (gridRefs[activeTab].current) { //  && !showDetails

            if (gridData[activeTab]) {
                //   const localData = gridData[activeTab].map(item => ({

                //     id: item.id,
                //     STN: item.station_code,
                //     Taddrs: item.station_addresses.length,
                //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
                //   }));    
                // console.log("🚀 ~ localData ~ localData:", localData)
                const source = {
                    datatype: 'json',
                    id: `${activeTab}-`,
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'address', type: 'string' },
                        { name: 'handler_email_id', type: 'string' },
                        { name: 'handler_phone_no', type: 'string' },
                        { name: 'company_name', type: 'string' },
                        { name: 'handler_org_id', type: 'string' },

                    ],
                    localdata: gridData[activeTab],
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                // console.log('localdata', source.localdata)
                const columns = [
                    // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                    { text: 'Handler Name', filtertype: 'textbox', datafield: 'company_name', width: '20%', cellclassname: '', },
                    { text: 'Email', filtertype: 'textbox', datafield: 'handler_email_id', width: '28%', cellclassname: '', },
                    { text: 'Phone Number', filtertype: 'textbox', datafield: 'handler_phone_no', width: '20%', cellclassname: '', },
                    { text: 'Address', filtertype: 'textbox', datafield: 'address', width: '20%', cellclassname: '', },
                    
                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    selectionmode: 'checkbox',
                    pageable: false,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
                window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRefs[activeTab].current).on('rowclick', (event) => {
                    console.log('event', event);
                    const args = event.args.row.bounddata;
                    console.log('args', args);
                    const sendRowId = gridData[activeTab];
                    console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
                    setSelectedRowData(args, { station_id: args.uid });
                    setItems(args.recovery_emails)
                    setShowDetails(true);
                    const transformedData = {
                        ...args,
                        agent_type: args.regd,
                        email: args.contact_email
                    };
                    setSelectedAddress(transformedData)
                });
                window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                // row selection by checkbox
                window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        const selectedRowId = selectedRow.uid;
                        if (!gridSelect.some(row => row.uid === selectedRowId)) {
                            setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                        }
                    } else {
                        if (event.args.rowindex.length > 0) {
                            const allIds = gridData[activeTab];
                            setGridSelect(allIds);
                        } else {
                            setGridSelect([]);
                        }
                    }
                });
                window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.address_id;
                        setGridSelect(prevSelection => prevSelection.filter(row => row.address_id !== unselectedRowId));
                    }
                });
            } else {
                const columns = [
                    { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
                    { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
                ];
            }
        }
    }, [activeTab, gridData, showDetails]);
    // console.log('101', gridSelect);
    // row click function start
    const handleMoveToActArc = async () => {
        console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? '0' : '1';
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            const uldNumbers = gridSelect && gridSelect.map(num => num.address_id)
            try {
                const res = await withRFSToken.post(ULDADDRESSACTARC, { address_ids: uldNumbers, type: sendAction })
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            fetchDataGrid()
                            if (activeTab == 'Active') {
                                toast.success('ULD Data moved to Arhive');
                                // fetchDataGrid()
                            } else {
                                toast.success('ULD Data moved to Active');
                                // fetchDataGrid()
                            }
                        }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    // Email section
    const emailArray = selectedRowData && selectedRowData.recovery_emails;
    // console.log("🚀 ~ StationDetails ~ emailArray:", emailArray)
    const [emailShow, setEmailShow] = useState(false);
    const inputEmailShow = () => setEmailShow(true);
    const [inputData, setInputData] = useState("");
    const [items, setItems] = useState([]);
    const [editEmail, setEditEmail] = useState('');
    const [toggleButton, setToggleButton] = useState(false);

    const AddEmail = async () => {
        if (inputData == '') {
            // Alert('Please input Email');
            console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
        }
        else if (inputData && toggleButton) {
            // if (index){
            const NewItemData = {
                // id: new Date().getTime().toString(),
                address_id: selectedRowData.address_id,
                recovery_email: inputData,
                email_key: editEmail,
            }
            // }
            try {
                const res = await withRFSToken.post(ULDADDRESSRECMAIL, NewItemData)
                    .then(function (res) {
                        if (res.data.response_code === 200) {
                            const innerData = res.data.response_data;
                            console.log("🚀 ~ .then ~ innerData:", innerData)
                            setItems(innerData);
                            // setExportGrid(innerData.export);
                            fetchDataGrid();
                        } else {
                            toast.error(res.data.response_msg)
                        }

                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // setItems(items.map((elem) => {
            //     if(elem.id === editEmail){
            //         return {...elem, name: inputData}
            //     }
            //     return elem;
            // }));
            setInputData('');
            setEditEmail(null);
            setToggleButton(false);
            setEmailShow(false);
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = (email) => {
                return emailRegex.test(email);
            };
            if (!validateEmail(inputData)) {
                toast.error('Invalid email address');
                setEmailShow(true);
            } else {
                const NewItemData = {
                    // id: new Date().getTime().toString(),
                    address_id: selectedRowData.address_id,
                    recovery_email: inputData
                }
                try {
                    const res = await withRFSToken.post(ULDADDRESSRECMAIL, NewItemData)
                        .then(function (res) {
                            if (res.data.response_code === 200) {
                                const innerData = res.data.response_data;
                                console.log("🚀 ~ .then ~ innerData:", innerData)
                                setItems(innerData);
                                fetchDataGrid();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                            // setExportGrid(innerData.export);
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                // setItems([...items, NewItemData]);
                setEmailShow(false);
            }

            // localStorage.setItem('TruckerEmail', JSON.stringify(NewItemData));
        }
        setInputData('');
        // setEmailShow(false);

    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteEmail = async (index) => {
        // const updatedItem = items.filter((curElem) => {
        //     return curElem.id !== index;
        // });
        try {
            const res = await withRFSToken.post(DELETERECEMAIL, { address_id: selectedRowData.address_id, email_key: index })
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        console.log("🚀 ~ .then ~ innerData:", innerData)
                        toast.success(res.data.response_msg);
                        setItems(innerData);
                        fetchDataGrid();
                    } else {
                        toast.error(res.data.response_msg);
                    }

                    // setExportGrid(innerData.export);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // setItems(updatedItem);
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    // Email section End


    return (
        <>
            {console.log('selected', inputAddress)}
            <Row className='mt-3'>
                <Col className='pt-4 px-4 brd_rgt' lg="6">
                    <h4>Station Details</h4>
                    <p>Add stations and manage stations by selecting the station.</p>
                    <h3> {rowData.args.STN} </h3>
                    {/* {console.log('456',rowData.args)} */}
                    <div className='d-flex justify-content-between pt-3'>
                        <div>
                            <h4>Manage Address </h4>
                            <p>Manage Address and add address</p>
                        </div>
                        <div className='align-self-center'>
                            <button onClick={modalShow} className='add_adres'>+ Add Address</button>
                        </div>

                    </div>
                    <div className='addresses'>
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="station_grid">
                            <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                <div className='moveto_btn'>
                                    <button onClick={handleMoveToActArc}> <img src={Arcv} /></button>
                                </div>
                                <div ref={gridRefs.Active} className='staion_grid' ></div>
                            </Tab>
                            <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                                <div className='moveto_btn'>
                                    <button onClick={handleMoveToActArc}> <img title='' src={Active} /></button>
                                </div>
                                <div ref={gridRefs.Archived} className='staion_grid' ></div>
                            </Tab>
                        </Tabs>
                       

                    </div>
          
                </Col>
                <Col className='pt-4 px-4' lg="6">
                {selectedRowData && (
                        <>{console.log('selectedRowData', selectedRowData)}
                            <div className='handler_name'>
                                <div className='raedit'><Button variant="link" onClick={() => modalEditShow(selectedRowData)}><FontAwesomeIcon icon={faPencil} /> Edit</Button></div>
                                <h2>{selectedRowData.company_name}</h2>

                                <div className='handler_info'>
                                    <ul>
                                        <h3>Handler Information</h3>
                                        <li><span>Agent/Handler </span> : <span>{selectedRowData.agent_or_handler == 'A' ? 'Agent' : 'Handler'}, {selectedRowData.address_2} </span></li>
                                        <li><span>Registered Hub</span> : <span>{selectedRowData.regd == '1' ? 'Registered' : 'Non Registered'}</span></li>
                                        <li><span>Contact Email </span> : <span>{selectedRowData.handler_email_id}</span></li>
                                        <li><span>Phone No </span> : <span>{selectedRowData.handler_phone_no}</span></li>
                                        <li><span>Address </span> : <span>{selectedRowData.address}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div className='mt-3 '>
                                <div className='d-flex justify-content-between py-2'>
                                    <h6>Recovery Email Address</h6>
                                    <div className='align-self-center'>
                                        <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                                    </div>

                                </div>
                                <div className='addresses'>
                                    {emailShow &&
                                        <>
                                            <div className='add_email'>
                                                <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                                {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                            </div>
                                        </>
                                    }
                                    <div className='showItem'>{console.log('555', items)}
                                        {items && items.map((elem, index) => {
                                            return (
                                                <div className='eachItem' key={index}>
                                                    <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                                    {/* <button>Edit</button> */}
                                                    <div className='request_email'>
                                                        <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                        <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* <ImageUpload attachable_type={"uld_s_address"} attachable_id={selectedRowData.address_id} attachments={selectedRowData.attachments} /> */}
                        </>
                    )}
                </Col>
            </Row>

            

            <Modal show={show} onHide={modalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={modalClose}>
                    <Modal.Title>{editMode == 'E' ? 'Edit Address' : `Add Address - ${rowData.args.STN}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name</Form.Label>
                        {/* <Form.Control type="text" onChange={handleChange} name='company_name' placeholder="Company Name" /> */}
                        <Select
                            options={handlerList}
                            onChange={(selected) => {
                                setInputAddress(prevFormData => {
                                    const newFormData = { ...prevFormData, handler_org_id: selected.value, handler_email_id: selected.email };
                                    return newFormData;
                                });
                            }}
                            placeholder="Select Handler"
                            className='select_handler'
                            name='handler_org_id'
                            value={handlerList.find(option => option.value == inputAddress.handler_org_id) || ''}
                        />
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID  <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link></Form.Label>
                        {/* <Form.Control type="text" onChange={handleChange} name='handler_email_id' placeholder="E-mail" /> */}
                        {inputAddress?.handler_email_id?.map((email, index) => (
                            <div key={index} className="d-flex align-items-center position-relative mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="E-mail"
                                    value={email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                    className=""
                                />
                                {inputAddress.handler_email_id.length > 1 && (
                                   
                                    <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>
                             
                                )}
                            </div>
                        ))}
                    </Form.Group>
                   
                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleChange} name='address' placeholder="Address" />
                    </Form.Group>
                   
                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control
                            type="number"
                            onChange={handleChange} name='handler_phone_no'
                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
                            placeholder="Number"
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        {editMode == 'E' ? 'Update' : 'Add'} Address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RecoveryStationDetails;